import { useQuery } from '@tanstack/react-query';
import { fetchEvOfferings } from '@services/productOfferingService';
import type { Plan } from '@t/productOffering.types';

export const useEvOfferings = (sessionId: string, enabled: boolean) =>
  useQuery<Plan[]>({
    queryKey: ['evOfferings', sessionId],
    queryFn: () => fetchEvOfferings(sessionId),
    enabled: !!sessionId && enabled,
  });
